/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_HintInputs */



/**
* | output |
* | --- |
* | "You can always change this on the Team page." |
*
* @param {Manager_Question_HintInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_hint = /** @type {((inputs?: Manager_Question_HintInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_HintInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je kan dit altijd wijzigen op de Teampagina.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous pouvez toujours le modifier sur la page Équipe.")
	return /** @type {LocalizedString} */ ("You can always change this on the Team page.")
});